<template>
  <div class="auth-wrapper auth-cover">
    <div class="auth-inner row m-0">
      <!-- Brand logo-->
      <div class="d-none d-lg-flex col-lg-3 align-items-center justify-content-center">
        <div class="text-center">
          <img
            src="@/assets/images/logo/logo.png"
            alt="Logo"
            class="img-fluid"
            style="max-width: 200px;"
          />
          <h2 class="mt-2 text-primary">Cortinarte</h2>
          <p class="text-muted">Gestión Comercial de Cortinas para Hoteles</p>
        </div>
      </div>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <div class="d-none d-lg-flex col-lg-4 align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <img
            class="img-fluid auth-cover-illustration"
            src="@/assets/images/pages/auth-v1-top-bg.png"
            alt="auth-cover-illustration"
          />
        </div>
      </div>
      <!-- /Left Text-->

      <!-- Reset Password Form-->
      <div class="d-flex col-lg-5 align-items-center auth-bg p-4 p-lg-5">
        <div class="col-12 col-sm-12 col-md-10 col-lg-12 px-xl-2 mx-auto">
          <div class="text-center mb-4">
            <h2 class="card-title fw-bold mb-1">Restablecer Contraseña 🔐</h2>
            <p class="card-text mb-2">Ingresa tu nueva contraseña</p>
          </div>

          <form class="auth-login-form mt-2" @submit.prevent="resetPassword">
            <div class="mb-3">
              <label for="new-password" class="form-label">Nueva Contraseña</label>
              <div class="input-group input-group-merge form-password-toggle">
                <input
                  id="new-password"
                  v-model="form.newPassword"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control form-control-merge"
                  name="new-password"
                  placeholder="············"
                  aria-describedby="new-password"
                  tabindex="1"
                  required
                />
                <span class="input-group-text cursor-pointer" @click="showPassword = !showPassword">
                  <i :class="showPassword ? 'feather-eye-off' : 'feather-eye'"></i>
                </span>
              </div>
            </div>
            
            <div class="mb-3">
              <label for="confirm-password" class="form-label">Confirmar Contraseña</label>
              <div class="input-group input-group-merge form-password-toggle">
                <input
                  id="confirm-password"
                  v-model="form.confirmPassword"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  class="form-control form-control-merge"
                  name="confirm-password"
                  placeholder="············"
                  aria-describedby="confirm-password"
                  tabindex="2"
                  required
                />
                <span class="input-group-text cursor-pointer" @click="showConfirmPassword = !showConfirmPassword">
                  <i :class="showConfirmPassword ? 'feather-eye-off' : 'feather-eye'"></i>
                </span>
              </div>
            </div>
            
            <button
              class="btn btn-primary w-100"
              tabindex="3"
              type="submit"
              :disabled="loading"
            >
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ loading ? 'Restableciendo...' : 'Restablecer Contraseña' }}
            </button>
          </form>

          <p class="text-center mt-3">
            <router-link to="/login" class="text-decoration-none">
              <i class="feather-arrow-left me-1"></i>
              Volver al Login
            </router-link>
          </p>
        </div>
      </div>
      <!-- /Reset Password Form-->
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService.js'

export default {
  name: 'ResetPassword',
  data() {
    return {
      form: {
        newPassword: '',
        confirmPassword: ''
      },
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      token: null
    }
  },
  mounted() {
    // Obtener el token de la URL
    this.token = this.$route.query.token
    
    if (!this.token) {
      this.$router.push('/login')
      return
    }
    
    // Validar el token
    this.validateToken()
  },
  methods: {
    async validateToken() {
      try {
        console.log('Validando token:', this.token)
        const response = await authService.validateResetToken(this.token)
        console.log('Respuesta de validación:', response)
        if (!response.success) {
          alert('Token inválido o expirado. Por favor, solicita un nuevo enlace de restablecimiento.')
          this.$router.push('/login')
        }
      } catch (error) {
        console.error('Error al validar token:', error)
        console.error('Detalles del error:', {
          message: error.message,
          response: error.response,
          request: error.request,
          config: error.config
        })
        alert('Error al validar el token. Por favor, solicita un nuevo enlace de restablecimiento.')
        this.$router.push('/login')
      }
    },
    
    async resetPassword() {
      if (!this.form.newPassword || !this.form.confirmPassword) {
        alert('Por favor, completa todos los campos.')
        return
      }
      
      if (this.form.newPassword !== this.form.confirmPassword) {
        alert('Las contraseñas no coinciden.')
        return
      }
      
      if (this.form.newPassword.length < 6) {
        alert('La contraseña debe tener al menos 6 caracteres.')
        return
      }
      
      this.loading = true
      console.log('Restableciendo contraseña con token:', this.token)
      
      try {
        const response = await authService.resetPasswordWithToken({
          token: this.token,
          newPassword: this.form.newPassword
        })
        
        console.log('Contraseña restablecida:', response)
        this.loading = false
        
        if (response.success) {
          alert('¡Contraseña restablecida exitosamente! Ya puedes iniciar sesión con tu nueva contraseña.')
          this.$router.push('/login')
        } else {
          alert('Error: ' + response.message)
        }
        
      } catch (error) {
        console.error('Error al restablecer contraseña:', error)
        this.loading = false
        
        let errorMessage = 'Error al restablecer la contraseña. '
        if (error.response) {
          if (error.response.status === 400) {
            errorMessage += 'Token inválido o expirado. Solicita un nuevo enlace.'
          } else if (error.response.status === 500) {
            errorMessage += 'Error interno del servidor. Inténtalo más tarde.'
          } else {
            errorMessage += `Servidor respondió con código ${error.response.status}`
          }
        } else if (error.request) {
          errorMessage += 'No se pudo conectar con el servidor. Verifica tu conexión.'
        } else {
          errorMessage += 'Error inesperado.'
        }
        
        alert(errorMessage)
      }
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-inner {
  width: 100%;
  max-width: 1200px;
}

/* Área del logo con fondo gris */
.col-lg-3 {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
}

/* Área de texto con fondo gris */
.col-lg-4 {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
}

.auth-bg {
  background: #ffffff;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-login-form {
  background: transparent;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: none;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
}

.form-control {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 0.7rem 0.9rem;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  min-height: 42px;
}

.form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.3rem;
  font-weight: 600;
  font-size: 0.9rem;
  min-height: 42px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.card-title {
  color: #2c3e50;
  font-size: 1.4rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.card-text {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  font-weight: 400;
}

.form-label {
  color: #5a5a5a;
  font-weight: 500;
  font-size: 0.85rem;
  margin-bottom: 0.4rem;
}

.input-group-text {
  background: transparent;
  border: 1px solid #d1d5db;
  border-left: none;
  cursor: pointer;
}

.cursor-pointer {
  cursor: pointer;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

/* Responsive adjustments */
@media (max-width: 991.98px) {
  .auth-wrapper {
    padding: 1rem;
  }
  
  .auth-bg {
    min-height: auto;
    padding: 2rem 1rem;
  }
  
  .auth-login-form {
    padding: 2rem;
  }
}

@media (max-width: 575.98px) {
  .auth-login-form {
    padding: 1.5rem;
    margin: 0.5rem;
  }
  
  .card-title {
    font-size: 1.5rem;
  }
}
</style>
